export default "/images/add_task_app_preview_3.webp"